import { render, staticRenderFns } from "./verenviosmasivos.vue?vue&type=template&id=559a9eee"
import script from "./verenviosmasivos.vue?vue&type=script&lang=js"
export * from "./verenviosmasivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports